import React, { Fragment } from 'react';
import { Flex, Image, Stack, Text, Box, Grid, Icon } from '@tonic-ui/react';
import { useTranslation, Trans } from 'react-i18next';
import signUpBackground from '../../assets/images/cloudone-signup-bg.png';
import cloudGraphic from '../../assets/images/cloud-diagram.png';
import ExternalLink from '../../components/external-link/external-link';
import RegistrationForm from './registration-form';

const TrialPage = () => {
  const { t } = useTranslation();

  return (
    <Flex
      direction={{ sm: 'column', md: 'row' }}
      flex="1"
      fontFamily="opensans"
      fontWeight="300"
      minHeight="100%"
    >
      <Box backgroundColor="gray:10" flex="1" position="relative">
        {/* Background image has a dynamic clipping effect along its bottom edge. clip-path affect all child elements
          so it needs to be rendered in a separate part of DOM. */}
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          clipPath="url(#clip-shape)"
          background={`url(${signUpBackground}) no-repeat`}
        />
        <Stack
          position="relative"
          height="100%"
          padding={{ sm: '48px 5%', md: '56px 36px' }}
          justifyContent="space-between"
          alignItems="center"
        >
          <Text
            size="5xl"
            lineHeight="57px"
            color="white"
            textAlign="center"
            marginBottom="24px"
            fontWeight={400}
            fontSize="48px"
            fontFamily="interstate"
          >
            <Trans i18nKey="trendCloudOne" />
          </Text>
          <Image
            alt="Image of Trend Cloud One protections"
            src={cloudGraphic}
            flex="1"
            marginBottom="37px"
            // Set maximum size of image and ensure proper resizing of img when width or height is limited.
            maxHeight="440px"
            maxWidth="100%"
            objectFit="contain"
          />
          <Box flex="0 0 auto">
            <Text marginBottom="37px" fontSize="28px" fontWeight={400} lineHeight="48px">
              <Trans i18nKey="singleSolution" />
            </Text>
            <Grid rowGap="8x" gridGap="3x" gridTemplateColumns="24px 1fr">
              {((t('signUpCloudOneBullets') as unknown) as string[]).map((text) => (
                <Fragment key={text}>
                  <Stack
                    borderRadius="50%"
                    justifyContent="center"
                    alignItems="center"
                    backgroundColor="#CC0000"
                    color="white"
                    width="24px"
                    height="24px"
                  >
                    <Icon icon="check-bold" width="4x" height="4x" />
                  </Stack>
                  <Box fontSize="lg" lineHeight="lg">
                    {text}
                  </Box>
                </Fragment>
              ))}
            </Grid>
            <Box mt="78px" fontWeight="300">
              <ExternalLink
                href="https://aws.amazon.com/marketplace/pp/prodview-g232pyu6l55l4"
                showIcon={false}
                style={{ wordBreak: 'break-all' }}
              >
                <Trans i18nKey="getPricing" />
              </ExternalLink>
            </Box>
          </Box>
        </Stack>
      </Box>

      <Flex justifyContent="center" flex="1" alignItems="center" backgroundColor="white:primary">
        <Box margin={{ sm: '24px 36px', lg: '24px 114px' }} marginBottom="0">
          <RegistrationForm isTrialPage={true} />
          {/*Create a custom clip path used for a dynamic clipping effect on cloudone-signup-bg.png. Creates a curved bottom that is the same for all viewport widths. */}
          <svg width="0" height="0">
            <defs>
              <clipPath id="clip-shape" clipPathUnits="objectBoundingBox">
                <path
                  d="M0 0.2930 V0 H1 V0.2377 C0.9194 0.2643 0.76 0.2945 0.6 0.3115
            C0.3951 0.3332 0.1019 0.3115 0 0.2930Z"
                />
              </clipPath>
            </defs>
          </svg>
        </Box>
      </Flex>
    </Flex>
  );
};

TrialPage.displayName = 'TrialPage';
export default TrialPage;
